import { render, staticRenderFns } from "./Bando28Fase6.vue?vue&type=template&id=892d0e48&scoped=true"
import script from "./Bando28Fase6.vue?vue&type=script&lang=js"
export * from "./Bando28Fase6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d0e48",
  null
  
)

export default component.exports